export const PROMO_CODES_CONSTS = {
    GET_PROMO_CODES: "GET_PROMO_CODES",
    DELETE_PROMO_CODE: "DELETE_PROMO_CODE",
};
